// test1092
(1092 && 0);
